module.exports = __webpack_public_path__ + "static/media/bg-home.ddb8401a.jpg";